@if (invoice().fullyLoaded) {
    <div class="px-2">
        <div class="row mb-2">
            <div class="col-md-4 mb-2">
                <div class="row mb-2">
                    <div class="col">
                        <iim-card [header]="'Rechnungsinformationen' | translate">
                            <div class="px-2">
                                <div class="row" *showOnDebug>
                                    <div class="col">
                                        <strong>{{ 'ID' | translate }}</strong>
                                    </div>
                                    <div class="col-auto">
                                        <span copyToClipboard>{{ invoice().id }}</span>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col">
                                        <strong>{{ 'Lieferant' | translate }}</strong>
                                    </div>
                                    <div class="col-auto">
                                        @if (invoice().supplierName) {
                                            <div
                                                [innerHtml]="
                                                    (invoice().supplierName
                                                        | supplierDisplayName: invoice().supplierNumber)
                                                        | highlight: searchQuery()
                                                "
                                            ></div>
                                        } @else {
                                            <i class="text-description">
                                                {{ 'Kein Lieferant angegeben' | translate }}
                                            </i>
                                        }
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col">
                                        <strong>{{ 'Rechnungsnummer' | translate }}</strong>
                                    </div>
                                    <div class="col-auto">
                                        @if (invoice().invoiceNumber) {
                                            <span
                                                copyToClipboard
                                                [innerHtml]="invoice().invoiceNumber | highlight: searchQuery()"
                                            ></span>
                                        } @else {
                                            <i class="text-description">
                                                {{ 'Keine Rechnungsnummer angegeben' | translate }}
                                            </i>
                                        }
                                    </div>
                                </div>
                                @if (invoice().collectiveInvoiceNumber) {
                                    <div class="row">
                                        <div class="col">
                                            <strong>{{ 'Sammelrechnungsnummer' | translate }}</strong>
                                        </div>
                                        <div
                                            class="col-auto"
                                            copyToClipboard
                                            [innerHtml]="invoice().collectiveInvoiceNumber | highlight: searchQuery()"
                                        ></div>
                                    </div>
                                }
                                <div class="row">
                                    <div class="col">
                                        <strong>{{ 'Buchungsdatum' | translate }}</strong>
                                    </div>
                                    <div class="col-auto">
                                        @if (invoice().bookingDate) {
                                            {{ invoice().bookingDate | dayjs: 'L LT' }}
                                        } @else {
                                            <i class="text-description">
                                                {{ 'Kein Buchungsdatum angegeben' | translate }}
                                            </i>
                                        }
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col">
                                        <strong>{{ 'Rechnungsdatum' | translate }}</strong>
                                    </div>
                                    <div class="col-auto">
                                        @if (invoice().documentDate) {
                                            {{ invoice().documentDate | dayjs: 'L' }}
                                        } @else {
                                            <i class="text-description">
                                                {{ 'Kein Rechnungsdatum angegeben' | translate }}
                                            </i>
                                        }
                                    </div>
                                </div>
                                @if (invoice().paymentUntil) {
                                    <div class="row">
                                        <div class="col">
                                            <strong>{{ 'Fälligkeitsdatum' | translate }}</strong>
                                        </div>
                                        <div class="col-auto">
                                            {{ invoice().paymentUntil | dayjs: 'L' }}
                                        </div>
                                    </div>
                                }
                                @if (invoice().paymentDate) {
                                    <div class="row d-none">
                                        <div class="col">
                                            <strong>{{ 'Zahlungsdatum' | translate }}</strong>
                                        </div>
                                        <div class="col-auto">
                                            {{ invoice().paymentDate | dayjs: 'L' }}
                                        </div>
                                    </div>
                                }
                                @if (invoice().note) {
                                    <div class="row mt-2">
                                        <div class="col">
                                            <strong>
                                                <em class="fas fa-comment pe-1 text-description"></em>
                                                {{ 'Buchungsvermerk' | translate }}:
                                            </strong>
                                        </div>
                                        <div
                                            class="col-12"
                                            [innerHTML]="invoice().note | highlight: searchQuery()"
                                        ></div>
                                    </div>
                                }
                            </div>
                        </iim-card>
                    </div>
                </div>
                @let orderRelationsLength = invoice().orderRelations.length;
                @let receiptRelationsLength = invoice().receiptRelations.length;
                @if (orderRelationsLength || receiptRelationsLength) {
                    <div class="row">
                        <div class="col">
                            <iim-card [header]="'Verknüpfungen' | translate">
                                <div class="px-2">
                                    @if (orderRelationsLength) {
                                        <div class="row">
                                            <div class="col">
                                                <h5>{{ 'Bestellungen' | translate }}</h5>
                                                @for (order of invoice().orderRelations; track order) {
                                                    <div
                                                        class="linked-document cursor-pointer scale--hover shadow--hover"
                                                        (click)="navigateToOrder(order)"
                                                    >
                                                        <span>{{ order.orderErpNumber ?? order.orderId }}</span>
                                                    </div>
                                                }
                                            </div>
                                        </div>
                                    }
                                    @if (receiptRelationsLength) {
                                        <div class="row">
                                            <div class="col">
                                                <h5>{{ 'Lieferungen' | translate }}</h5>
                                                @for (receipt of invoice().receiptRelations; track receipt) {
                                                    <div
                                                        class="linked-document cursor-pointer scale--hover shadow--hover"
                                                        (click)="
                                                            navigateToReceipt(receipt.receiptId, receipt.receiptNumber)
                                                        "
                                                    >
                                                        <span>{{ receipt.receiptNumber }}</span>
                                                    </div>
                                                }
                                            </div>
                                        </div>
                                    }
                                </div>
                            </iim-card>
                        </div>
                    </div>
                }
            </div>
            <div class="col mb-2">
                <iim-card [header]="'Positionen' | translate" [footer]="positionFooter">
                    @for (item of invoice().items; track item) {
                        <document-item [imagePreview]="true">
                            <document-item-position-indicator>
                                {{ 'Position \{\{position\}\}' | translate: { position: item.position } }}
                            </document-item-position-indicator>
                            <document-item-name>
                                {{ item.name }}
                            </document-item-name>
                            <document-item-description>
                                {{ item.description }}
                            </document-item-description>
                            <document-item-attribute [spacingBelow]="true">
                                <document-item-label>
                                    {{ 'Artikelnummer' | translate }}
                                </document-item-label>
                                <document-item-value>
                                    {{ item.supplierArticleNumber }}
                                </document-item-value>
                            </document-item-attribute>

                            <document-item-price>
                                <document-item-label></document-item-label>
                                <document-item-value>
                                    {{ item.quantity.amount }}
                                    {{ item.quantity.unit | unit: item.quantity.amount }}
                                </document-item-value>
                            </document-item-price>
                            <document-item-price>
                                <document-item-label>
                                    {{ 'Gesamtpreis' | translate }}
                                </document-item-label>
                                <document-item-value>
                                    <strong class="font-10">
                                        @if (
                                            item.linePrice !== null &&
                                            item.linePrice?.amount !== null &&
                                            item.linePrice?.currency !== null
                                        ) {
                                            <display-currency
                                                [value]="item.linePrice.amount"
                                                [currencyCode]="item.linePrice.currency"
                                            />
                                        } @else {
                                            <i class="text-muted">
                                                {{ 'keine Preisinformationen vorhanden' | translate }}
                                            </i>
                                        }
                                    </strong>
                                </document-item-value>
                            </document-item-price>
                        </document-item>
                    } @empty {
                        <div class="alert alert-info text-center text-muted p-4">
                            <i class="fas fa-info-circle me-2"></i>
                            {{ 'Keine Positionen vorhanden' | translate }}
                        </div>
                    }
                    <ng-template #positionFooter>
                        <div class="col">
                            <div class="row justify-content-end">
                                <div class="col-auto align-self-end justify-content-end">
                                    <div class="row align-items-center">
                                        <div class="col">{{ 'Preis Netto' | translate }}</div>
                                        <div class="col-auto">
                                            <span class="fw-bold">
                                                @if (invoice().netAmount !== null && invoice().currency !== null) {
                                                    <display-currency
                                                        [value]="invoice().netAmount"
                                                        [currencyCode]="invoice().currency"
                                                    />
                                                } @else {
                                                    <i class="text-muted">
                                                        {{ 'keine Preisinformationen vorhanden' | translate }}
                                                    </i>
                                                }
                                            </span>
                                        </div>
                                    </div>
                                    @for (tax of invoice().taxes; track tax.percent) {
                                        <div class="row align-items-center">
                                            <div class="col">
                                                {{
                                                    'zzgl. \{\{percent\}\}% MwSt.' | translate: { percent: tax.percent }
                                                }}
                                            </div>
                                            <div class="col-auto">
                                                <span class="fw-bold">
                                                    <display-currency
                                                        [value]="tax.amount.amount"
                                                        [currencyCode]="tax.amount.currency"
                                                    />
                                                </span>
                                            </div>
                                        </div>
                                    }
                                    <div class="row align-items-center">
                                        <div class="col">{{ 'Preis Brutto' | translate }}</div>
                                        <div class="col-auto">
                                            <span class="fw-bold font-11">
                                                @if (invoice().grossAmount !== null && invoice().currency !== null) {
                                                    <display-currency
                                                        [value]="invoice().grossAmount"
                                                        [currencyCode]="invoice().currency"
                                                    />
                                                } @else {
                                                    <i class="text-muted">
                                                        {{ 'keine Preisinformationen vorhanden' | translate }}
                                                    </i>
                                                }
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </ng-template>
                </iim-card>
            </div>
        </div>
    </div>
}
